import ShadowCard from './ShadowCard'

export default ShadowCard
